import React from "react";
import {Field} from "formik";
import {SelectButton} from "primereact/selectbutton";

export default function NsFieldSelectbutton({
                                                name,
                                                label = '',
                                                value = '',
                                                formikRef,
                                                onChange = () => {
                                                },
                                                options = [],
                                                validate = () => {
                                                },
                                                itemTemplate = undefined,
                                                isMobile = false,
                                                isFormFieldInvalid,
                                            }) {

    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={SelectButton}
                pt={{
                    button: () => ({style: isMobile ? {'width': '33%'} : {}})
                }}
                options={options}
                onChange={(e) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, e.target.value);
                    }
                    onChange(e);
                }}
                optionLabel={label}
                itemTemplate={itemTemplate}
                value={value}
                validate={validate}
                invalid={isFormFieldInvalid()}
            />
            :
            <SelectButton
                name={name}
                pt={{
                    button: () => ({style: isMobile ? {'width': '33%'} : {}})
                }}
                options={options}
                onChange={onChange}
                optionLabel={label}
                itemTemplate={itemTemplate}
                value={value}
                invalid={isFormFieldInvalid()}
            />
    );
}